import { useQuery } from "@tanstack/react-query";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { apiRelPagamentoProdutor } from "pages/relatorios/api/apiRelPagamentoProdutor";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, TableRelPagamentoProdutor } from "./TableRelPagamentoProdutor";

export function RelatorioPagamentoProdutor() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelPagamentoProdutor", params],
		queryFn: () => apiRelPagamentoProdutor({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiCalculo> = useMemo(() => {
		return {
			type: "default",
			fileName: "relatorio-pagamentos-produtores",
			options: {
				columns,
				data: registros,
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Pagamentos dos Produtores";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Pagamentos", "Produtores"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelPagamentoProdutor data={data?.registros} title={title} />}
		/>
	);
}
